window.messages = {
  en: {
  },
  'textResults.carrierCharges': 'We will in no way use your mobile number or any other personal information other than the intended purpose to deliver the services and support or carry out the transactions you have requested.  Standard text messaging rates may apply.'
};



// WEBPACK FOOTER //
// ./src/main/js/messages.js